import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["limit", "actors"];
import { generateActivityFiltersV2 } from '../utils';
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */
var generateV2MyActivityFilters = function generateV2MyActivityFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = filters.limit,
    actors = filters.actors,
    restFilters = _objectWithoutProperties(filters, _excluded);
  return generateActivityFiltersV2(restFilters);
};
export default generateV2MyActivityFilters;